//import { buff_line_by } from './GenerateReport.js';

/*export function toggleDetailsTable(){
    var detailed_table = document.getElementById("detailed_table_section");
    var detailed_table_btn = document.getElementById("toggle_details_table");
    if (detailed_table.classList.contains("hide_detailed_table")) {
        detailed_table.classList.remove("hide_detailed_table");
        detailed_table.classList.add("report_row");
        detailed_table_btn.innerText = "Hide Details Table";
    } else {
        detailed_table.classList.add("hide_detailed_table");
        detailed_table.classList.remove("report_row");
        detailed_table_btn.innerText = "Show Details Table";
    }
}*/

export function convertCoordinates(format) {
    const latCells = document.querySelectorAll('.latitude');
    const lonCells = document.querySelectorAll('.longitude');

    latCells.forEach((latCell, index) => {
        const lat = parseFloat(latCell.textContent);
        const formattedLat = lat.toFixed(2); // Example: Round to 2 decimal places
        latCells[index].textContent = formattedLat;
    });

    lonCells.forEach((lonCell, index) => {
        const lon = parseFloat(lonCell.textContent);
        const formattedLon = lon.toFixed(2); // Example: Round to 2 decimal places
        lonCells[index].textContent = formattedLon;
    });
}

export function waypoints_only(route_data) {
	const seen = new Set();
	return (route_data ?? []).filter((item) => {
		if (seen.has(item.waypoint_number)) return false;
		seen.add(item.waypoint_number);
		return true;
	});
}

export function activate_button_customise(checkbox){
    var button = document.getElementById(checkbox.value);
    if (button) {
        button.click();
    } else {
        console.error("Button not found with ID: " + checkbox.value);
    }
}
export function activate_button_customise2(button_id){
    var button = document.getElementById(button_id);
    if (button) {
        button.click();
    } else {
        console.error("Button not found with ID: " + button_id);
    }
}
export function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}